/**
 * Checks whether the result of a media query matches the size.
 *
 * @param {number} size
 * @param {string} order viewport size order. Possible values are: min or max. Default: min
 * @return {boolean}
 */
export const breakpoint = (size, order) => {
    if (!size) {
        return false;
    }

    const dir = order && order === 'max' ? 'max' : 'min';

    return window.matchMedia(`(${dir}-width: ${size}px)`).matches;
};

export const isMobile = () => breakpoint(767, 'max');
